import React from "react";
import { Section } from "./Section";
import { images } from "../data/landing";
export function AuthorMessage() {
  return <Section cta="Start My Clinical Reference Library" data-id="element-19" data-mp="3m8zcelo473yf">
      <div className="grid items-start gap-10 lg:grid-cols-[400px_1fr] lg:gap-14" data-id="element-20" data-mp="3vjbj4tpt8q0">
        <div className="mx-auto w-full max-w-sm lg:sticky lg:top-6" data-id="element-21" data-mp="3xm49wm95fyf">
          <img src={images.author} alt="Dr. Michael Carter, author of HOF Clinical Blueprint" className="aspect-[4/5] w-full rounded-3xl object-cover ring-1 ring-gold/40" loading="lazy" data-id="element-22" data-mp="3w0dhra2qyxzh" />
          <p className="mt-4 text-center font-serif text-2xl font-bold text-cream" data-id="element-23" data-mp="3hafqumdfnu6l">Dr. Michael Carter</p>
          <p className="text-center text-sm text-gold" data-id="element-24" data-mp="3cb33m0ingl3h">Author of HOF CLINICAL BLUEPRINT™</p>
        </div>

        <div data-id="element-25" data-mp="wjnkq0bhw3xg">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-26" data-mp="wjf9ecv0t6od">
            Why I created HOF CLINICAL BLUEPRINT™
          </p>
          <h2 className="mt-3 font-serif text-[2rem] font-bold leading-tight text-cream sm:text-5xl" data-id="element-27" data-mp="cmnvlpkf821p">
            A Message from Dr. Michael Carter
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-28" data-mp="gmo834nym364">
            <p data-id="element-29" data-mp="lnvfv3q3r2cs">
              I created HOF CLINICAL BLUEPRINT™ because I believe that continuing professional education should be
              organized, practical, and relevant to the situations facial aesthetic practitioners encounter in their
              work.
            </p>
            <p data-id="element-30" data-mp="3u470109fdubs">
              In a specialized field, information is often spread across courses, textbooks, professional resources, and
              personal notes. Even when practitioners have studied the relevant concepts, finding and organizing that
              information can be challenging.
            </p>
            <p data-id="element-31" data-mp="36d1mirqyje4n">
              I wanted to bring essential educational topics together in a structured collection that practitioners
              could use for ongoing study and professional reference. That is why I organized this system into six
              volumes, each addressing a different part of facial aesthetic clinical safety and practice — and included
              five specialized resources focused on case review, patient assessment, warning signs, documentation, and
              clinical safety preparation.
            </p>
            <p className="text-cream" data-id="element-32" data-mp="2kd3yhbzj6py8">
              My intention is straightforward: to give you an organized educational resource that complements your
              professional training and supports a more systematic approach to reviewing clinical information.
            </p>
            <p data-id="element-33" data-mp="2u8xbewh5wlgj">
              I do not believe that a digital guide can replace experience, appropriate qualifications, or clinical
              judgment. But I do believe that well-organized educational materials can make it easier to review
              important concepts and maintain a structured approach to professional learning.
            </p>
            <p data-id="element-34" data-mp="1mijhqj08zn74">Thank you for allowing me to be part of your continuing education.</p>
          </div>
          <p className="mt-6 font-serif text-2xl italic text-gold" data-id="element-35" data-mp="1rjqpii2e4mds">— Dr. Michael Carter</p>
        </div>
      </div>
    </Section>;
}